import { UPDATE_SCHEDULED_REPORT_ERROR, UPDATE_SCHEDULED_REPORT_SUCCESS } from './actionTypes';

export const updateScheduledReportSuccess = report => ({
    type: UPDATE_SCHEDULED_REPORT_SUCCESS,
    payload: report,
});

export const updateScheduledReportError = error => ({ type: UPDATE_SCHEDULED_REPORT_ERROR, payload: error });
